import { AppState } from '../reducers/root';
import { WorkTableState } from '../slices/workTable';

export const getWorkTableState = (state: AppState): WorkTableState =>
  state.workTable;
